/**
 * This event is dispatched when the queue got updated and remaining counts got changed.
 */ export const REMAINING_EVENT = "RealQueue/Remaining";
